<template>
  <div class="avue-top">
    <div class="top-bar__left">
      <div class="avue-breadcrumb" :class="[{ 'avue-breadcrumb--active': isCollapse }]" v-if="showCollapse">
        <i class="icon-navicon" @click="setCollapse"></i>
      </div>
    </div>
    <div class="top-bar__title">
      <div class="top-bar__item top-bar__item--show" v-if="showMenu">
        <top-menu ref="topMenu"></top-menu>
      </div>
      <span class="top-bar__item" v-if="showSearch">
        <top-search></top-search>
      </span>
    </div>
    <div class="top-bar__right">
      <div class="my-audit">
        <el-badge slot="reference" :max="99" class="top-bar__badge">
          <i class="el-icon-s-check" @click="handleAuditClick()"></i>
        </el-badge>
      </div>
      <div class="my-message">

        <el-popover placement="bottom" width="400" v-model="popoverVisible">
          <div class="message-list">
            <div class="message-list-header">我的消息</div>
            <div class="line"></div>
            <ul v-if="massageList.length">
              <template v-for='(item, index) in massageList'>
                <li @click="toMyMessage(item)" :key="index" v-if="vaildData(permission[messageType[item.messageTypeParent].hide], false)">
                  <div class="message_icon">
                    <div class="message_icon_box">
                      <el-badge :hidden="item.num <= 0" slot="reference" :max="99" :value="item.num"
                        class="top-bar__badge">
                        <img :src="messageType[item.messageTypeParent].icon" />
                      </el-badge>
                    </div>
                    <div class="message_content">
                      <span>{{ messageType[item.messageTypeParent].name }}</span>
                      <span v-if="item.num > 0">您收到一个一条待处理的更新提醒</span>
                    </div>
                  </div>
                  <span>{{ item.latestDate }}</span>
                </li>
              </template>
            </ul>
            <el-empty
              v-if="
                !vaildData(permission.business_message, false) &&
                !vaildData(permission.postrental_message, false) &&
                !vaildData(permission.approval_message, false)
              "
              description="暂无可查看的消息类型"
            ></el-empty>
          </div>
          <el-badge :hidden="num <= 0" slot="reference" :max="99" :value="num" class="top-bar__badge">
            <i class="el-icon-bell" @click="handleClick()"></i>
          </el-badge>
        </el-popover>
      </div>


      <div class="top-bar__item" style="display: flex; align-items: center;">
        <strong>员工编号: {{ userInfo.businessUserCode }}</strong>
      </div>
      <el-tooltip v-if="showLock" effect="dark" :content="$t('navbar.lock')" placement="bottom">
        <div class="top-bar__item">
          <top-lock></top-lock>
        </div>
      </el-tooltip>
      <el-tooltip v-if="showColor" effect="dark" :content="$t('navbar.color')" placement="bottom">
        <div class="top-bar__item">
          <top-color></top-color>
        </div>
      </el-tooltip>
      <!-- <el-tooltip v-if="showDebug"
                  effect="dark"
                  :content="logsFlag?$t('navbar.bug'):logsLen+$t('navbar.bugs')"
                  placement="bottom">
        <div class="top-bar__item">
          <top-logs></top-logs>
        </div>
      </el-tooltip> -->
      <el-tooltip v-if="showTheme" effect="dark" :content="$t('navbar.theme')" placement="bottom">
        <div class="top-bar__item top-bar__item--show">
          <top-theme></top-theme>
        </div>
      </el-tooltip>
      <el-tooltip v-if="showFullScren" effect="dark"
        :content="isFullScren ? $t('navbar.screenfullF') : $t('navbar.screenfull')" placement="bottom">
        <div class="top-bar__item">
          <i :class="isFullScren ? 'icon-tuichuquanping' : 'icon-quanping'" @click="handleScreen"></i>
        </div>
      </el-tooltip>
      <img class="top-bar__img" :src="userInfo.avatar">
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ userInfo.userName }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/wel/index">{{ $t('navbar.dashboard') }}</router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/info/index">{{ $t('navbar.userinfo') }}</router-link>
          </el-dropdown-item>
          <el-dropdown-item v-if="this.website.switchMode" @click.native="switchDept">{{ $t('navbar.switchDept') }}
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout" divided>{{ $t('navbar.logOut') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog title="用户信息选择" append-to-body :close-on-click-modal="false" :close-on-press-escape="false"
        :visible.sync="userBox" width="350px">
        <avue-form ref="form" :option="userOption" v-model="userForm" @submit="submitSwitch" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { resetRouter } from '@/router/router'
import { mapGetters, mapState, mapActions } from "vuex";
import { fullscreenToggel, listenfullscreen } from "@/util/util";
import topLock from "./top-lock";
import topMenu from "./top-menu";
import topSearch from "./top-search";
import topTheme from "./top-theme";
import topLogs from "./top-logs";
import topColor from "./top-color";
import topNotice from './top-notice'
import topLang from "./top-lang";
import {confirmMessage} from '@/util/confirmDialogs'

export default {
  components: {
    topLock,
    topMenu,
    topSearch,
    topTheme,
    topLogs,
    topColor,
    topNotice,
    topLang
  },
  name: "top",
  data() {
    return {
      userBox: false,
      userForm: {
        deptId: '',
        roleId: ''
      },
      userOption: {
        labelWidth: 70,
        submitBtn: true,
        emptyBtn: false,
        submitText: '切换',
        column: [
          {
            label: '部门',
            prop: 'deptId',
            type: 'select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            dicUrl: '/api/blade-system/dept/select',
            span: 24,
            display: false,
            rules: [{
              required: true,
              message: "请选择部门",
              trigger: "blur"
            }],
          },
          {
            label: '角色',
            prop: 'roleId',
            type: 'select',
            props: {
              label: 'roleName',
              value: 'id'
            },
            dicUrl: '/api/blade-system/role/select',
            span: 24,
            display: false,
            rules: [{
              required: true,
              message: "请选择角色",
              trigger: "blur"
            }],
          },
        ]
      },
      messageList: [],
      messageType: {
        '01': {
          icon: require('@/assets/edit.png'),
          name: '业务流程消息',
          hide: 'business_message',
        },
        '02': {
          icon: require('@/assets/edit2.png'),
          name: '租后流程消息',
          hide: 'postrental_message',
        },
        '03': {
          icon: require('@/assets/edit3.png'),
          name: '签批流程消息',
          hide: 'approval_message',
        },
        // '04': {
        //   icon: require('@/assets/edit3.png'),
        //   name: '通知公告消息',
        //   hide: 'notice_message',
        // },
      },
      messageNum: 0,
      popoverVisible: false,
      newMessage: true,
    };
  },
  filters: {},
  async created() {
    let timer = setInterval(async() => {
      if(this.popoverVisible){
        this.popoverVisible=false;
        await this.GetMessage();
      }
      this.popoverVisible=false;
      this.GetMessageNum()
    }, 30000)
    await this.GetMessageNum();
    if((!this.currentNotifyInstance || this.currentNotifyInstance?.closed)&&(+this.num)){
      this.currentNotifyInstance = this.$notify.warning({
        title: '提示',
        message: `您有${this.num}条新的消息未读取！`,
        duration: 0,
      });
    }
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer);
      if(this.currentNotifyInstance){
        this.currentNotifyInstance.close()
        this.currentNotifyInstance =null;
      }
      timer = null;
    })
  },
  mounted() {
    listenfullscreen(this.setScreen);
  },
  watch: {
    '$store.state.user.num'(newValue,oldValue){
      if(!+newValue){
        if(this.currentNotifyInstance){
          this.currentNotifyInstance.close()
        }
        return
      }
      if(!this.currentNotifyInstance || this.currentNotifyInstance?.closed){
        this.currentNotifyInstance = this.$notify.warning({
          title: '提示',
          message: `您有${this.num}条新的消息未读取！`,
          duration: 0,
        });
      }
      if(newValue!==oldValue){
        if(this.currentNotifyInstance){
          this.currentNotifyInstance.message = `您有${this.num}条新的消息未读取！`
        }
      }
    }
  },
  computed: {
    ...mapState({
      showDebug: state => state.common.showDebug,
      showTheme: state => state.common.showTheme,
      showLock: state => state.common.showLock,
      showFullScren: state => state.common.showFullScren,
      showCollapse: state => state.common.showCollapse,
      showSearch: state => state.common.showSearch,
      showMenu: state => state.common.showMenu,
      showColor: state => state.common.showColor,
      num: state => state.user.num,
      massageList: state => state.user.massageList
    }),
    ...mapGetters([
      "userInfo",
      "isFullScren",
      "tagWel",
      "tagList",
      "isCollapse",
      "tag",
      "logsLen",
      "logsFlag",
      "permission"
    ])
  },
  methods: {
    ...mapActions(['GetMessageNum', 'GetMessage']),
    // 消息弹框
    async handleClick(e) {
      try {
        if(!this.popoverVisible) {
          await this.GetMessage();
          await this.GetMessageNum();
        }
      } catch (err) {
        return
      }
    },
    handleAuditClick() {
      this.$router.push({ path: "/workbench/myAudit" });
    },
    // async allMessageNum(){
    //   try{
    //     let res = await getAllMessageNum();
    //     if(res?.data?.code!==200) throw new Error('出错了！');
    //     this.messageNum = res?.data?.data ?? 0;
    //   }catch(err){
    //     return
    //   }
    // },
    handleScreen() {
      fullscreenToggel();
    },
    setCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    setScreen() {
      this.$store.commit("SET_FULLSCREN");
    },
    switchDept() {
      const userId = this.userInfo.user_id;
      const deptColumn = this.findObject(this.userOption.column, "deptId");
      deptColumn.dicUrl = `/api/blade-system/dept/select?userId=${userId}`;
      deptColumn.display = true;
      const roleColumn = this.findObject(this.userOption.column, "roleId");
      roleColumn.dicUrl = `/api/blade-system/role/select?userId=${userId}`;
      roleColumn.display = true;
      this.userBox = true;
    },
    submitSwitch(form, done) {
      this.$store.dispatch("refreshToken", form).then(() => {
        this.userBox = false;
        this.$router.push({ path: "/" });
      })
      done();
    },
    async logout() {
      try {
        await confirmMessage({
          messagesHtml:this.$t("logoutTip"),
          type: "warning"
        },true)
        this.$store.dispatch("LogOut").then(() => {
          resetRouter();
          this.$router.push({ path: "/login" });
        });
      } catch (error) {
        return
      }

      // this.$confirm(this.$t("logoutTip"), this.$t("tip"), {
      //   confirmButtonText: this.$t("submitText"),
      //   cancelButtonText: this.$t("cancelText"),
      //   type: "warning"
      // }).then(() => {
      //   this.$store.dispatch("LogOut").then(() => {
      //     resetRouter();
      //     this.$router.push({ path: "/login" });
      //   });
      // });
    },
    toMyMessage(item) {
      const { messageTypeParent } = item
      const time = new Date().getTime()
      this.$router.push({ path: "/loan/loanMessage", query: { messageTypeParent,time } });
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar__badge {
  display: flex;
  line-height: normal;
  cursor: pointer;

  .el-icon-bell,
  .el-icon-s-check {
    font-size: 18px;
    line-height: normal;
  }

  ::v-deep .el-badge__content.is-fixed {
    top: 0px;
    padding: 0 4px;
    height: 14px;
    line-height: 14px;
  }
}

.my-message {
  padding-right: 10px;
}

.my-audit {
  padding-right: 10px;
}

.message-list {
  position: relative;

  .message-list-header {
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    padding-bottom: 6px;
    font-weight: 500;
  }

  .line {
    height: 1px;
    border-bottom: 1px solid #EBEEF5;
    margin: 0 -12px;
    position: absolute;
    width: calc(100% + 24px);
  }

  ul {
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      list-style: none;
      border-bottom: 1px solid #EBEEF5;
      padding: 6px 0;
      cursor: pointer;
    }

    .message_icon {
      display: flex;

      .message_icon_box {
        display: flex;
        align-items: center;
        margin-right: 14px;
      }

      img {
        width: 32px;
        height: 32px;
      }
    }

    .message_content {
      height: 44px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      span:first-child {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}
</style>
